import { createContext, useContext, useState } from "react";

// Création du contexte
const GameContext = createContext(null);

// Hook personnalisé pour accéder au contexte
export const useGame = () => {
  const context = useContext(GameContext);
  if (!context) {
    throw new Error("useGame doit être utilisé à l'intérieur d'un GameProvider");
  }
  return context;
};

// Fournisseur du contexte
export const GameProvider = ({ children }) => {
  const [gameData, setGameData] = useState({
    parcoursId: null,
    villageId: null,
  });

  // Démarrer une nouvelle session de jeu (initialiser la progression)
  const startNewGame = (parcoursId, villageId, type = "villages") => {
    setGameData({
      parcoursId,
      villageId,
    });

    // Sauvegarde en localStorage (optionnel selon ton besoin réel)
    if(type === "villages") {
      localStorage.setItem("currentParcoursId", parcoursId);
      localStorage.setItem("currentVillageId", villageId);
    } else {
      localStorage.setItem("currentGameInfoId", parcoursId);
      localStorage.setItem("currentGameId", villageId);
    }
  };

  // Réinitialisation des données de jeu (utile pour un logout par ex)
  const clearGameData = (type = "villages") => {
    setGameData({
      parcoursId: null,
      villageId: null,
    });

    // Nettoyage du localStorage
    if(type === "villages") {
      localStorage.removeItem("currentParcoursId");
      localStorage.removeItem("currentVillageId");
    } else {
      localStorage.removeItem("currentVersionId");
      localStorage.removeItem("currentGameId");
    }
  };

  return (
    <GameContext.Provider value={{ gameData, startNewGame, clearGameData }}>
      {children}
    </GameContext.Provider>
  );
};
